<script>
	import { Table } from "sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { navigate } from "svelte-routing";

	export let data;

	const joinComma = (cars, i) => {
		if (i) {
			return cars.concat(",", " ");
		} else {
			return cars;
		}
	};
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th class="col-2">Station ID.</th>
				<th class="col-2">Car(s)</th>
				<th>Name</th>
				<th>Ev Charging Company</th>
				<th>No. of chargers</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { name, evCompany, stationId, evsesCount, carPlates }}
				<tr>
					<td>
						<p>
							<span> {stationId} </span>
						</p>
					</td>
					<td>
						<p class="link text-right">
							{#if carPlates.length !== 0}
								{#each carPlates as { plateNumber }, i}
									{#if carPlates?.length > 1}
										<!-- svelte-ignore missing-declaration -->
										<!-- svelte-ignore a11y-click-events-have-key-events -->
										<span
											class="link-text mx-1"
											on:click={() =>
												navigate(
													`/car-management?plateNumber=${plateNumber}`
												)}
											>{joinComma(
												plateNumber,
												carPlates?.length - 1 !== i
											)}</span
										>
									{:else}
										<!-- svelte-ignore missing-declaration -->
										<!-- svelte-ignore a11y-click-events-have-key-events -->
										<span
											class="link link-text"
											on:click={() =>
												navigate(
													`/car-management?plateNumber=${plateNumber}`
												)}
										>
											{plateNumber}</span
										>
									{/if}
								{/each}
							{/if}
						</p>
					</td>
					<td>
						<p>
							<span> {name} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {evCompany} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {evsesCount} </span>
						</p>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.totalCount || 0} />
	<CustomModal />
</LoaderContainer>
